module.exports = __webpack_public_path__ + "img/4465a9e9348954fc48dc65c5e571348fef9596d9.0b79e3dd.png";